import store from "@/store";
import { getDeviceUuid, getNativeOS } from "@/plugins/Const";
import { getToken } from "@/utils/auth";

export default async (to, from, next) => {
    if (getToken()) {
        store.dispatch('fetchData')
    } else {
        store.dispatch('Login', {
            loginId: getDeviceUuid(),
            model: getNativeOS()
        }).then(() => {
            store.dispatch('fetchData')
        });
    }
    next();
};